"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConversionMetadata = exports.SnakeSansDTO = exports.MaybeUrl = exports.ConversionType = exports.META_CONVERSION_TYPE_KEY = exports.CONVERSION_TYPE = void 0;
require("reflect-metadata");
var CONVERSION_TYPE;
(function (CONVERSION_TYPE) {
    CONVERSION_TYPE["potential_url"] = "maybeUrl";
    CONVERSION_TYPE["snake_case_sans_dto"] = "snake_sans_dto";
})(CONVERSION_TYPE = exports.CONVERSION_TYPE || (exports.CONVERSION_TYPE = {}));
exports.META_CONVERSION_TYPE_KEY = Symbol('conversion:type');
const ConversionType = (type) => Reflect.metadata(exports.META_CONVERSION_TYPE_KEY, type);
exports.ConversionType = ConversionType;
const MaybeUrl = () => (0, exports.ConversionType)(CONVERSION_TYPE.potential_url);
exports.MaybeUrl = MaybeUrl;
const SnakeSansDTO = () => (0, exports.ConversionType)(CONVERSION_TYPE.snake_case_sans_dto);
exports.SnakeSansDTO = SnakeSansDTO;
const getConversionMetadata = (dto, property) => {
    return Reflect.getMetadata(exports.META_CONVERSION_TYPE_KEY, dto, property);
};
exports.getConversionMetadata = getConversionMetadata;
